/**
 * Created by hernanherreros on 2019-05-28
 */
import { i18n } from '../../../providers/Locale/localeProvider'
import { utils } from 'react-trazo-forms'

export const messages = {
  email: () => i18n._('Debe ingresar un email válido'),
  required: () => i18n._('Este campo es requerido'),
  rut: () => i18n._('Debe ingresar un RUT válido'),
}

export const getValue = (data: any, key: string, defaultValue: any) => {
  if (!data) {
    return defaultValue
  }

  return data.hasOwnProperty(key) && data[key] ? data[key] : defaultValue
}

export const getAgeList = () => {
  const array = new Array(99)
  return utils.options.arrayToOptions(array)
}

export const countryOptions = () => ([
  { key: 'Afganistán', value: 'Afganistán', label: i18n._('Afganistán') },
  { key: 'Albania', value: 'Albania', label: i18n._('Albania') },
  { key: 'Alemania', value: 'Alemania', label: i18n._('Alemania') },
  { key: 'Andorra', value: 'Andorra', label: i18n._('Andorra') },
  { key: 'Angola', value: 'Angola', label: i18n._('Angola') },
  { key: 'Antigua y Barbuda', value: 'Antigua y Barbuda', label: i18n._('Antigua y Barbuda') },
  { key: 'Arabia Saudita', value: 'Arabia Saudita', label: i18n._('Arabia Saudita') },
  { key: 'Argelia', value: 'Argelia', label: i18n._('Argelia') },
  { key: 'Argentina', value: 'Argentina', label: i18n._('Argentina') },
  { key: 'Armenia', value: 'Armenia', label: i18n._('Armenia') },
  { key: 'Australia', value: 'Australia', label: i18n._('Australia') },
  { key: 'Austria', value: 'Austria', label: i18n._('Austria') },
  { key: 'Azerbaiyán', value: 'Azerbaiyán', label: i18n._('Azerbaiyán') },
  { key: 'Bahamas', value: 'Bahamas', label: i18n._('Bahamas') },
  { key: 'Bangladés', value: 'Bangladés', label: i18n._('Bangladés') },
  { key: 'Barbados', value: 'Barbados', label: i18n._('Barbados') },
  { key: 'Baréin', value: 'Baréin', label: i18n._('Baréin') },
  { key: 'Bélgica', value: 'Bélgica', label: i18n._('Bélgica') },
  { key: 'Belice', value: 'Belice', label: i18n._('Belice') },
  { key: 'Benín', value: 'Benín', label: i18n._('Benín') },
  { key: 'Bielorrusia', value: 'Bielorrusia', label: i18n._('Bielorrusia') },
  { key: 'Birmania', value: 'Birmania', label: i18n._('Birmania') },
  { key: 'Bolivia', value: 'Bolivia', label: i18n._('Bolivia') },
  { key: 'Bosnia y Herzegovina', value: 'Bosnia y Herzegovina', label: i18n._('Bosnia y Herzegovina') },
  { key: 'Botsuana', value: 'Botsuana', label: i18n._('Botsuana') },
  { key: 'Brasil', value: 'Brasil', label: i18n._('Brasil') },
  { key: 'Brunéi', value: 'Brunéi', label: i18n._('Brunéi') },
  { key: 'Bulgaria', value: 'Bulgaria', label: i18n._('Bulgaria') },
  { key: 'Burkina Faso', value: 'Burkina Faso', label: i18n._('Burkina Faso') },
  { key: 'Burundi', value: 'Burundi', label: i18n._('Burundi') },
  { key: 'Bután', value: 'Bután', label: i18n._('Bután') },
  { key: 'Cabo Verde', value: 'Cabo Verde', label: i18n._('Cabo Verde') },
  { key: 'Camboya', value: 'Camboya', label: i18n._('Camboya') },
  { key: 'Camerún', value: 'Camerún', label: i18n._('Camerún') },
  { key: 'Canadá', value: 'Canadá', label: i18n._('Canadá') },
  { key: 'Catar', value: 'Catar', label: i18n._('Catar') },
  { key: 'Chad', value: 'Chad', label: i18n._('Chad') },
  { key: 'China', value: 'China', label: i18n._('China') },
  { key: 'Chipre', value: 'Chipre', label: i18n._('Chipre') },
  { key: 'Ciudad del Vaticano', value: 'Ciudad del Vaticano', label: i18n._('Ciudad del Vaticano') },
  { key: 'Colombia', value: 'Colombia', label: i18n._('Colombia') },
  { key: 'Comoras', value: 'Comoras', label: i18n._('Comoras') },
  { key: 'Corea del Norte', value: 'Corea del Norte', label: i18n._('Corea del Norte') },
  { key: 'Corea del Sur', value: 'Corea del Sur', label: i18n._('Corea del Sur') },
  { key: 'Costa de Marfil', value: 'Costa de Marfil', label: i18n._('Costa de Marfil') },
  { key: 'Costa Rica', value: 'Costa Rica', label: i18n._('Costa Rica') },
  { key: 'Croacia', value: 'Croacia', label: i18n._('Croacia') },
  { key: 'Cuba', value: 'Cuba', label: i18n._('Cuba') },
  { key: 'Dinamarca', value: 'Dinamarca', label: i18n._('Dinamarca') },
  { key: 'Dominica', value: 'Dominica', label: i18n._('Dominica') },
  { key: 'Ecuador', value: 'Ecuador', label: i18n._('Ecuador') },
  { key: 'Egipto', value: 'Egipto', label: i18n._('Egipto') },
  { key: 'El Salvador', value: 'El Salvador', label: i18n._('El Salvador') },
  { key: 'Emiratos Árabes Unidos', value: 'Emiratos Árabes Unidos', label: i18n._('Emiratos Árabes Unidos') },
  { key: 'Eritrea', value: 'Eritrea', label: i18n._('Eritrea') },
  { key: 'Eslovaquia', value: 'Eslovaquia', label: i18n._('Eslovaquia') },
  { key: 'Eslovenia', value: 'Eslovenia', label: i18n._('Eslovenia') },
  { key: 'España', value: 'España', label: i18n._('España') },
  { key: 'Estados Unidos', value: 'Estados Unidos', label: i18n._('Estados Unidos') },
  { key: 'Estonia', value: 'Estonia', label: i18n._('Estonia') },
  { key: 'Etiopía', value: 'Etiopía', label: i18n._('Etiopía') },
  { key: 'Filipinas', value: 'Filipinas', label: i18n._('Filipinas') },
  { key: 'Finlandia', value: 'Finlandia', label: i18n._('Finlandia') },
  { key: 'Fiyi', value: 'Fiyi', label: i18n._('Fiyi') },
  { key: 'Francia', value: 'Francia', label: i18n._('Francia') },
  { key: 'Gabón', value: 'Gabón', label: i18n._('Gabón') },
  { key: 'Gambia', value: 'Gambia', label: i18n._('Gambia') },
  { key: 'Georgia', value: 'Georgia', label: i18n._('Georgia') },
  { key: 'Ghana', value: 'Ghana', label: i18n._('Ghana') },
  { key: 'Granada', value: 'Granada', label: i18n._('Granada') },
  { key: 'Grecia', value: 'Grecia', label: i18n._('Grecia') },
  { key: 'Guatemala', value: 'Guatemala', label: i18n._('Guatemala') },
  { key: 'Guyana', value: 'Guyana', label: i18n._('Guyana') },
  { key: 'Guinea', value: 'Guinea', label: i18n._('Guinea') },
  { key: 'Guinea ecuatorial', value: 'Guinea ecuatorial', label: i18n._('Guinea ecuatorial') },
  { key: 'Guinea-Bisáu', value: 'Guinea-Bisáu', label: i18n._('Guinea-Bisáu') },
  { key: 'Haití', value: 'Haití', label: i18n._('Haití') },
  { key: 'Honduras', value: 'Honduras', label: i18n._('Honduras') },
  { key: 'Hungría', value: 'Hungría', label: i18n._('Hungría') },
  { key: 'India', value: 'India', label: i18n._('India') },
  { key: 'Indonesia', value: 'Indonesia', label: i18n._('Indonesia') },
  { key: 'Irak', value: 'Irak', label: i18n._('Irak') },
  { key: 'Irán', value: 'Irán', label: i18n._('Irán') },
  { key: 'Irlanda', value: 'Irlanda', label: i18n._('Irlanda') },
  { key: 'Islandia', value: 'Islandia', label: i18n._('Islandia') },
  { key: 'Islas Marshall', value: 'Islas Marshall', label: i18n._('Islas Marshall') },
  { key: 'Islas Salomón', value: 'Islas Salomón', label: i18n._('Islas Salomón') },
  { key: 'Israel', value: 'Israel', label: i18n._('Israel') },
  { key: 'Italia', value: 'Italia', label: i18n._('Italia') },
  { key: 'Jamaica', value: 'Jamaica', label: i18n._('Jamaica') },
  { key: 'Japón', value: 'Japón', label: i18n._('Japón') },
  { key: 'Jordania', value: 'Jordania', label: i18n._('Jordania') },
  { key: 'Kazajistán', value: 'Kazajistán', label: i18n._('Kazajistán') },
  { key: 'Kenia', value: 'Kenia', label: i18n._('Kenia') },
  { key: 'Kirguistán', value: 'Kirguistán', label: i18n._('Kirguistán') },
  { key: 'Kiribati', value: 'Kiribati', label: i18n._('Kiribati') },
  { key: 'Kuwait', value: 'Kuwait', label: i18n._('Kuwait') },
  { key: 'Laos', value: 'Laos', label: i18n._('Laos') },
  { key: 'Lesoto', value: 'Lesoto', label: i18n._('Lesoto') },
  { key: 'Letonia', value: 'Letonia', label: i18n._('Letonia') },
  { key: 'Líbano', value: 'Líbano', label: i18n._('Líbano') },
  { key: 'Liberia', value: 'Liberia', label: i18n._('Liberia') },
  { key: 'Libia', value: 'Libia', label: i18n._('Libia') },
  { key: 'Liechtenstein', value: 'Liechtenstein', label: i18n._('Liechtenstein') },
  { key: 'Lituania', value: 'Lituania', label: i18n._('Lituania') },
  { key: 'Luxemburgo', value: 'Luxemburgo', label: i18n._('Luxemburgo') },
  { key: 'Macedonia del Norte', value: 'Macedonia del Norte', label: i18n._('Macedonia del Norte') },
  { key: 'Madagascar', value: 'Madagascar', label: i18n._('Madagascar') },
  { key: 'Malasia', value: 'Malasia', label: i18n._('Malasia') },
  { key: 'Malaui', value: 'Malaui', label: i18n._('Malaui') },
  { key: 'Maldivas', value: 'Maldivas', label: i18n._('Maldivas') },
  { key: 'Malí', value: 'Malí', label: i18n._('Malí') },
  { key: 'Malta', value: 'Malta', label: i18n._('Malta') },
  { key: 'Marruecos', value: 'Marruecos', label: i18n._('Marruecos') },
  { key: 'Mauricio', value: 'Mauricio', label: i18n._('Mauricio') },
  { key: 'Mauritania', value: 'Mauritania', label: i18n._('Mauritania') },
  { key: 'México', value: 'México', label: i18n._('México') },
  { key: 'Micronesia', value: 'Micronesia', label: i18n._('Micronesia') },
  { key: 'Moldavia', value: 'Moldavia', label: i18n._('Moldavia') },
  { key: 'Mónaco', value: 'Mónaco', label: i18n._('Mónaco') },
  { key: 'Mongolia', value: 'Mongolia', label: i18n._('Mongolia') },
  { key: 'Montenegro', value: 'Montenegro', label: i18n._('Montenegro') },
  { key: 'Mozambique', value: 'Mozambique', label: i18n._('Mozambique') },
  { key: 'Namibia', value: 'Namibia', label: i18n._('Namibia') },
  { key: 'Nauru', value: 'Nauru', label: i18n._('Nauru') },
  { key: 'Nepal', value: 'Nepal', label: i18n._('Nepal') },
  { key: 'Nicaragua', value: 'Nicaragua', label: i18n._('Nicaragua') },
  { key: 'Níger', value: 'Níger', label: i18n._('Níger') },
  { key: 'Nigeria', value: 'Nigeria', label: i18n._('Nigeria') },
  { key: 'Noruega', value: 'Noruega', label: i18n._('Noruega') },
  { key: 'Nueva Zelanda', value: 'Nueva Zelanda', label: i18n._('Nueva Zelanda') },
  { key: 'Omán', value: 'Omán', label: i18n._('Omán') },
  { key: 'Países Bajos', value: 'Países Bajos', label: i18n._('Países Bajos') },
  { key: 'Pakistán', value: 'Pakistán', label: i18n._('Pakistán') },
  { key: 'Palaos', value: 'Palaos', label: i18n._('Palaos') },
  { key: 'Panamá', value: 'Panamá', label: i18n._('Panamá') },
  { key: 'Papúa Nueva Guinea', value: 'Papúa Nueva Guinea', label: i18n._('Papúa Nueva Guinea') },
  { key: 'Paraguay', value: 'Paraguay', label: i18n._('Paraguay') },
  { key: 'Perú', value: 'Perú', label: i18n._('Perú') },
  { key: 'Polonia', value: 'Polonia', label: i18n._('Polonia') },
  { key: 'Portugal', value: 'Portugal', label: i18n._('Portugal') },
  { key: 'Reino Unido', value: 'Reino Unido', label: i18n._('Reino Unido') },
  { key: 'República Centroafricana', value: 'República Centroafricana', label: i18n._('República Centroafricana') },
  { key: 'República Checa', value: 'República Checa', label: i18n._('República Checa') },
  { key: 'República del Congo', value: 'República del Congo', label: i18n._('República del Congo') },
  { key: 'República Democrática del Congo', value: 'República Democrática del Congo', label: i18n._('República Democrática del Congo') },
  { key: 'República Dominicana', value: 'República Dominicana', label: i18n._('República Dominicana') },
  { key: 'República Sudafricana', value: 'República Sudafricana', label: i18n._('República Sudafricana') },
  { key: 'Ruanda', value: 'Ruanda', label: i18n._('Ruanda') },
  { key: 'Rumanía', value: 'Rumanía', label: i18n._('Rumanía') },
  { key: 'Rusia', value: 'Rusia', label: i18n._('Rusia') },
  { key: 'Samoa', value: 'Samoa', label: i18n._('Samoa') },
  { key: 'San Cristóbal y Nieves', value: 'San Cristóbal y Nieves', label: i18n._('San Cristóbal y Nieves') },
  { key: 'San Marino', value: 'San Marino', label: i18n._('San Marino') },
  { key: 'San Vicente y las Granadinas', value: 'San Vicente y las Granadinas', label: i18n._('San Vicente y las Granadinas') },
  { key: 'Santa Lucía', value: 'Santa Lucía', label: i18n._('Santa Lucía') },
  { key: 'Santo Tomé y Príncipe', value: 'Santo Tomé y Príncipe', label: i18n._('Santo Tomé y Príncipe') },
  { key: 'Senegal', value: 'Senegal', label: i18n._('Senegal') },
  { key: 'Serbia', value: 'Serbia', label: i18n._('Serbia') },
  { key: 'Seychelles', value: 'Seychelles', label: i18n._('Seychelles') },
  { key: 'Sierra Leona', value: 'Sierra Leona', label: i18n._('Sierra Leona') },
  { key: 'Singapur', value: 'Singapur', label: i18n._('Singapur') },
  { key: 'Siria', value: 'Siria', label: i18n._('Siria') },
  { key: 'Somalia', value: 'Somalia', label: i18n._('Somalia') },
  { key: 'Sri Lanka', value: 'Sri Lanka', label: i18n._('Sri Lanka') },
  { key: 'Suazilandia', value: 'Suazilandia', label: i18n._('Suazilandia') },
  { key: 'Sudán', value: 'Sudán', label: i18n._('Sudán') },
  { key: 'Sudán del Sur', value: 'Sudán del Sur', label: i18n._('Sudán del Sur') },
  { key: 'Suecia', value: 'Suecia', label: i18n._('Suecia') },
  { key: 'Suiza', value: 'Suiza', label: i18n._('Suiza') },
  { key: 'Surinam', value: 'Surinam', label: i18n._('Surinam') },
  { key: 'Tailandia', value: 'Tailandia', label: i18n._('Tailandia') },
  { key: 'Tanzania', value: 'Tanzania', label: i18n._('Tanzania') },
  { key: 'Tayikistán', value: 'Tayikistán', label: i18n._('Tayikistán') },
  { key: 'Timor Oriental', value: 'Timor Oriental', label: i18n._('Timor Oriental') },
  { key: 'Togo', value: 'Togo', label: i18n._('Togo') },
  { key: 'Tonga', value: 'Tonga', label: i18n._('Tonga') },
  { key: 'Trinidad y Tobago', value: 'Trinidad y Tobago', label: i18n._('Trinidad y Tobago') },
  { key: 'Túnez', value: 'Túnez', label: i18n._('Túnez') },
  { key: 'Turkmenistán', value: 'Turkmenistán', label: i18n._('Turkmenistán') },
  { key: 'Turquía', value: 'Turquía', label: i18n._('Turquía') },
  { key: 'Tuvalu', value: 'Tuvalu', label: i18n._('Tuvalu') },
  { key: 'Ucrania', value: 'Ucrania', label: i18n._('Ucrania') },
  { key: 'Uganda', value: 'Uganda', label: i18n._('Uganda') },
  { key: 'Uruguay', value: 'Uruguay', label: i18n._('Uruguay') },
  { key: 'Uzbekistán', value: 'Uzbekistán', label: i18n._('Uzbekistán') },
  { key: 'Vanuatu', value: 'Vanuatu', label: i18n._('Vanuatu') },
  { key: 'Venezuela', value: 'Venezuela', label: i18n._('Venezuela') },
  { key: 'Vietnam', value: 'Vietnam', label: i18n._('Vietnam') },
  { key: 'Yemen', value: 'Yemen', label: i18n._('Yemen') },
  { key: 'Yibuti', value: 'Yibuti', label: i18n._('Yibuti') },
  { key: 'Zambia', value: 'Zambia', label: i18n._('Zambia') },
  { key: 'Zimbabue', value: 'Zimbabue', label: i18n._('Zimbabue') },
])

export const communeOptions = [
  { key: 'Algarrobo', value: 'Algarrobo', label: 'Algarrobo' },
  { key: 'Alhué', value: 'Alhué', label: 'Alhué' },
  { key: 'Alto Bío Bío', value: 'Alto Bío Bío', label: 'Alto Bío Bío' },
  { key: 'Alto del Carmen', value: 'Alto del Carmen', label: 'Alto del Carmen' },
  { key: 'Alto Hospicio', value: 'Alto Hospicio', label: 'Alto Hospicio' },
  { key: 'Ancud', value: 'Ancud', label: 'Ancud' },
  { key: 'Andacollo', value: 'Andacollo', label: 'Andacollo' },
  { key: 'Angol', value: 'Angol', label: 'Angol' },
  { key: 'Antártica', value: 'Antártica', label: 'Antártica' },
  { key: 'Antofagasta', value: 'Antofagasta', label: 'Antofagasta' },
  { key: 'Antuco', value: 'Antuco', label: 'Antuco' },
  { key: 'Arauco', value: 'Arauco', label: 'Arauco' },
  { key: 'Arica', value: 'Arica', label: 'Arica' },
  { key: 'Aysén', value: 'Aysén', label: 'Aysén' },
  { key: 'Buin', value: 'Buin', label: 'Buin' },
  { key: 'Bulnes', value: 'Bulnes', label: 'Bulnes' },
  { key: 'Cabildo', value: 'Cabildo', label: 'Cabildo' },
  { key: 'Cabo de Hornos', value: 'Cabo de Hornos', label: 'Cabo de Hornos' },
  { key: 'Cabrero', value: 'Cabrero', label: 'Cabrero' },
  { key: 'Calama', value: 'Calama', label: 'Calama' },
  { key: 'Calbuco', value: 'Calbuco', label: 'Calbuco' },
  { key: 'Caldera', value: 'Caldera', label: 'Caldera' },
  { key: 'Calera de Tango', value: 'Calera de Tango', label: 'Calera de Tango' },
  { key: 'Calle Larga', value: 'Calle Larga', label: 'Calle Larga' },
  { key: 'Camarones', value: 'Camarones', label: 'Camarones' },
  { key: 'Camiña', value: 'Camiña', label: 'Camiña' },
  { key: 'Canela', value: 'Canela', label: 'Canela' },
  { key: 'Cañete', value: 'Cañete', label: 'Cañete' },
  { key: 'Carahue', value: 'Carahue', label: 'Carahue' },
  { key: 'Cartagena', value: 'Cartagena', label: 'Cartagena' },
  { key: 'Casablanca', value: 'Casablanca', label: 'Casablanca' },
  { key: 'Castro', value: 'Castro', label: 'Castro' },
  { key: 'Catemu', value: 'Catemu', label: 'Catemu' },
  { key: 'Cauquenes', value: 'Cauquenes', label: 'Cauquenes' },
  { key: 'Cerrillos', value: 'Cerrillos', label: 'Cerrillos' },
  { key: 'Cerro Navia', value: 'Cerro Navia', label: 'Cerro Navia' },
  { key: 'Chaitén', value: 'Chaitén', label: 'Chaitén' },
  { key: 'Chanco', value: 'Chanco', label: 'Chanco' },
  { key: 'Chañaral', value: 'Chañaral', label: 'Chañaral' },
  { key: 'Chépica', value: 'Chépica', label: 'Chépica' },
  { key: 'Chiguayante', value: 'Chiguayante', label: 'Chiguayante' },
  { key: 'Chile Chico', value: 'Chile Chico', label: 'Chile Chico' },
  { key: 'Chillán', value: 'Chillán', label: 'Chillán' },
  { key: 'Chillán Viejo', value: 'Chillán Viejo', label: 'Chillán Viejo' },
  { key: 'Chimbarongo', value: 'Chimbarongo', label: 'Chimbarongo' },
  { key: 'Chol Chol', value: 'Chol Chol', label: 'Chol Chol' },
  { key: 'Chonchi', value: 'Chonchi', label: 'Chonchi' },
  { key: 'Cisnes', value: 'Cisnes', label: 'Cisnes' },
  { key: 'Cobquecura', value: 'Cobquecura', label: 'Cobquecura' },
  { key: 'Cochamó', value: 'Cochamó', label: 'Cochamó' },
  { key: 'Cochrane', value: 'Cochrane', label: 'Cochrane' },
  { key: 'Codegua', value: 'Codegua', label: 'Codegua' },
  { key: 'Coelemu', value: 'Coelemu', label: 'Coelemu' },
  { key: 'Coihueco', value: 'Coihueco', label: 'Coihueco' },
  { key: 'Coinco', value: 'Coinco', label: 'Coinco' },
  { key: 'Colbún', value: 'Colbún', label: 'Colbún' },
  { key: 'Colchane', value: 'Colchane', label: 'Colchane' },
  { key: 'Colina', value: 'Colina', label: 'Colina' },
  { key: 'Collipulli', value: 'Collipulli', label: 'Collipulli' },
  { key: 'Coltauco', value: 'Coltauco', label: 'Coltauco' },
  { key: 'Combarbalá', value: 'Combarbalá', label: 'Combarbalá' },
  { key: 'Concepción', value: 'Concepción', label: 'Concepción' },
  { key: 'Conchalí', value: 'Conchalí', label: 'Conchalí' },
  { key: 'Concón', value: 'Concón', label: 'Concón' },
  { key: 'Constitución', value: 'Constitución', label: 'Constitución' },
  { key: 'Contulmo', value: 'Contulmo', label: 'Contulmo' },
  { key: 'Copiapó', value: 'Copiapó', label: 'Copiapó' },
  { key: 'Coquimbo', value: 'Coquimbo', label: 'Coquimbo' },
  { key: 'Coronel', value: 'Coronel', label: 'Coronel' },
  { key: 'Corral', value: 'Corral', label: 'Corral' },
  { key: 'Coyhaique', value: 'Coyhaique', label: 'Coyhaique' },
  { key: 'Cunco', value: 'Cunco', label: 'Cunco' },
  { key: 'Curacautín', value: 'Curacautín', label: 'Curacautín' },
  { key: 'Curacaví', value: 'Curacaví', label: 'Curacaví' },
  { key: 'Curaco de Vélez', value: 'Curaco de Vélez', label: 'Curaco de Vélez' },
  { key: 'Curanilahue', value: 'Curanilahue', label: 'Curanilahue' },
  { key: 'Curarrehue', value: 'Curarrehue', label: 'Curarrehue' },
  { key: 'Curepto', value: 'Curepto', label: 'Curepto' },
  { key: 'Curicó', value: 'Curicó', label: 'Curicó' },
  { key: 'Dalcahue', value: 'Dalcahue', label: 'Dalcahue' },
  { key: 'Diego de Almagro', value: 'Diego de Almagro', label: 'Diego de Almagro' },
  { key: 'Doñihue', value: 'Doñihue', label: 'Doñihue' },
  { key: 'El Bosque', value: 'El Bosque', label: 'El Bosque' },
  { key: 'El Carmen', value: 'El Carmen', label: 'El Carmen' },
  { key: 'El Monte', value: 'El Monte', label: 'El Monte' },
  { key: 'El Quisco', value: 'El Quisco', label: 'El Quisco' },
  { key: 'El Tabo', value: 'El Tabo', label: 'El Tabo' },
  { key: 'Empedrado', value: 'Empedrado', label: 'Empedrado' },
  { key: 'Ercilla', value: 'Ercilla', label: 'Ercilla' },
  { key: 'Estación Central', value: 'Estación Central', label: 'Estación Central' },
  { key: 'Florida', value: 'Florida', label: 'Florida' },
  { key: 'Freire', value: 'Freire', label: 'Freire' },
  { key: 'Freirina', value: 'Freirina', label: 'Freirina' },
  { key: 'Fresia', value: 'Fresia', label: 'Fresia' },
  { key: 'Frutillar', value: 'Frutillar', label: 'Frutillar' },
  { key: 'Futaleufú', value: 'Futaleufú', label: 'Futaleufú' },
  { key: 'Futrono', value: 'Futrono', label: 'Futrono' },
  { key: 'Galvarino', value: 'Galvarino', label: 'Galvarino' },
  { key: 'General Lagos', value: 'General Lagos', label: 'General Lagos' },
  { key: 'Gorbea', value: 'Gorbea', label: 'Gorbea' },
  { key: 'Graneros', value: 'Graneros', label: 'Graneros' },
  { key: 'Guaitecas', value: 'Guaitecas', label: 'Guaitecas' },
  { key: 'Hijuelas', value: 'Hijuelas', label: 'Hijuelas' },
  { key: 'Hualaihué', value: 'Hualaihué', label: 'Hualaihué' },
  { key: 'Hualañé', value: 'Hualañé', label: 'Hualañé' },
  { key: 'Hualpén', value: 'Hualpén', label: 'Hualpén' },
  { key: 'Hualqui', value: 'Hualqui', label: 'Hualqui' },
  { key: 'Huara', value: 'Huara', label: 'Huara' },
  { key: 'Huasco', value: 'Huasco', label: 'Huasco' },
  { key: 'Huechuraba', value: 'Huechuraba', label: 'Huechuraba' },
  { key: 'Illapel', value: 'Illapel', label: 'Illapel' },
  { key: 'Independencia', value: 'Independencia', label: 'Independencia' },
  { key: 'Iquique', value: 'Iquique', label: 'Iquique' },
  { key: 'Isla de Maipo', value: 'Isla de Maipo', label: 'Isla de Maipo' },
  { key: 'Isla de Pascua', value: 'Isla de Pascua', label: 'Isla de Pascua' },
  { key: 'Juan Fernández', value: 'Juan Fernández', label: 'Juan Fernández' },
  { key: 'La Calera', value: 'La Calera', label: 'La Calera' },
  { key: 'La Cisterna', value: 'La Cisterna', label: 'La Cisterna' },
  { key: 'La Cruz', value: 'La Cruz', label: 'La Cruz' },
  { key: 'La Estrella', value: 'La Estrella', label: 'La Estrella' },
  { key: 'La Florida', value: 'La Florida', label: 'La Florida' },
  { key: 'La Granja', value: 'La Granja', label: 'La Granja' },
  { key: 'La Higuera', value: 'La Higuera', label: 'La Higuera' },
  { key: 'La Ligua', value: 'La Ligua', label: 'La Ligua' },
  { key: 'La Pintana', value: 'La Pintana', label: 'La Pintana' },
  { key: 'La Reina', value: 'La Reina', label: 'La Reina' },
  { key: 'La Serena', value: 'La Serena', label: 'La Serena' },
  { key: 'La Unión', value: 'La Unión', label: 'La Unión' },
  { key: 'Lago Ranco', value: 'Lago Ranco', label: 'Lago Ranco' },
  { key: 'Lago Verde', value: 'Lago Verde', label: 'Lago Verde' },
  { key: 'Laguna Blanca', value: 'Laguna Blanca', label: 'Laguna Blanca' },
  { key: 'Laja', value: 'Laja', label: 'Laja' },
  { key: 'Lampa', value: 'Lampa', label: 'Lampa' },
  { key: 'Lanco', value: 'Lanco', label: 'Lanco' },
  { key: 'Las Cabras', value: 'Las Cabras', label: 'Las Cabras' },
  { key: 'Las Condes', value: 'Las Condes', label: 'Las Condes' },
  { key: 'Lautaro', value: 'Lautaro', label: 'Lautaro' },
  { key: 'Lebu', value: 'Lebu', label: 'Lebu' },
  { key: 'Licantén', value: 'Licantén', label: 'Licantén' },
  { key: 'Limache', value: 'Limache', label: 'Limache' },
  { key: 'Linares', value: 'Linares', label: 'Linares' },
  { key: 'Litueche', value: 'Litueche', label: 'Litueche' },
  { key: 'Llanquihue', value: 'Llanquihue', label: 'Llanquihue' },
  { key: 'Llay Llay', value: 'Llay Llay', label: 'Llay Llay' },
  { key: 'Lo Barnechea', value: 'Lo Barnechea', label: 'Lo Barnechea' },
  { key: 'Lo Espejo', value: 'Lo Espejo', label: 'Lo Espejo' },
  { key: 'Lo Prado', value: 'Lo Prado', label: 'Lo Prado' },
  { key: 'Lolol', value: 'Lolol', label: 'Lolol' },
  { key: 'Loncoche', value: 'Loncoche', label: 'Loncoche' },
  { key: 'Longaví', value: 'Longaví', label: 'Longaví' },
  { key: 'Lonquimay', value: 'Lonquimay', label: 'Lonquimay' },
  { key: 'Los Álamos', value: 'Los Álamos', label: 'Los Álamos' },
  { key: 'Los Andes', value: 'Los Andes', label: 'Los Andes' },
  { key: 'Los Ángeles', value: 'Los Ángeles', label: 'Los Ángeles' },
  { key: 'Los Lagos', value: 'Los Lagos', label: 'Los Lagos' },
  { key: 'Los Muermos', value: 'Los Muermos', label: 'Los Muermos' },
  { key: 'Los Sauces', value: 'Los Sauces', label: 'Los Sauces' },
  { key: 'Los Vilos', value: 'Los Vilos', label: 'Los Vilos' },
  { key: 'Lota', value: 'Lota', label: 'Lota' },
  { key: 'Lumaco', value: 'Lumaco', label: 'Lumaco' },
  { key: 'Machalí', value: 'Machalí', label: 'Machalí' },
  { key: 'Macul', value: 'Macul', label: 'Macul' },
  { key: 'Máfil', value: 'Máfil', label: 'Máfil' },
  { key: 'Maipú', value: 'Maipú', label: 'Maipú' },
  { key: 'Malloa', value: 'Malloa', label: 'Malloa' },
  { key: 'Marchigüe', value: 'Marchigüe', label: 'Marchigüe' },
  { key: 'María Elena', value: 'María Elena', label: 'María Elena' },
  { key: 'María Pinto', value: 'María Pinto', label: 'María Pinto' },
  { key: 'Mariquina', value: 'Mariquina', label: 'Mariquina' },
  { key: 'Maule', value: 'Maule', label: 'Maule' },
  { key: 'Maullín', value: 'Maullín', label: 'Maullín' },
  { key: 'Mejillones', value: 'Mejillones', label: 'Mejillones' },
  { key: 'Melipeuco', value: 'Melipeuco', label: 'Melipeuco' },
  { key: 'Melipilla', value: 'Melipilla', label: 'Melipilla' },
  { key: 'Molina', value: 'Molina', label: 'Molina' },
  { key: 'Monte Patria', value: 'Monte Patria', label: 'Monte Patria' },
  { key: 'Mostazal', value: 'Mostazal', label: 'Mostazal' },
  { key: 'Mulchén', value: 'Mulchén', label: 'Mulchén' },
  { key: 'Nacimiento', value: 'Nacimiento', label: 'Nacimiento' },
  { key: 'Nancagua', value: 'Nancagua', label: 'Nancagua' },
  { key: 'Navidad', value: 'Navidad', label: 'Navidad' },
  { key: 'Negrete', value: 'Negrete', label: 'Negrete' },
  { key: 'Ninhue', value: 'Ninhue', label: 'Ninhue' },
  { key: 'Nogales', value: 'Nogales', label: 'Nogales' },
  { key: 'Nueva Imperial', value: 'Nueva Imperial', label: 'Nueva Imperial' },
  { key: 'Ñiquén', value: 'Ñiquén', label: 'Ñiquén' },
  { key: 'Ñuñoa', value: 'Ñuñoa', label: 'Ñuñoa' },
  { key: 'O’Higgins', value: 'O’Higgins', label: 'O’Higgins' },
  { key: 'Olivar', value: 'Olivar', label: 'Olivar' },
  { key: 'Ollagüe', value: 'Ollagüe', label: 'Ollagüe' },
  { key: 'Olmué', value: 'Olmué', label: 'Olmué' },
  { key: 'Osorno', value: 'Osorno', label: 'Osorno' },
  { key: 'Ovalle', value: 'Ovalle', label: 'Ovalle' },
  { key: 'Padre Hurtado', value: 'Padre Hurtado', label: 'Padre Hurtado' },
  { key: 'Padre Las Casas', value: 'Padre Las Casas', label: 'Padre Las Casas' },
  { key: 'Paihuano', value: 'Paihuano', label: 'Paihuano' },
  { key: 'Paillaco', value: 'Paillaco', label: 'Paillaco' },
  { key: 'Paine', value: 'Paine', label: 'Paine' },
  { key: 'Palena', value: 'Palena', label: 'Palena' },
  { key: 'Palmilla', value: 'Palmilla', label: 'Palmilla' },
  { key: 'Panguipulli', value: 'Panguipulli', label: 'Panguipulli' },
  { key: 'Panquehue', value: 'Panquehue', label: 'Panquehue' },
  { key: 'Papudo', value: 'Papudo', label: 'Papudo' },
  { key: 'Paredones', value: 'Paredones', label: 'Paredones' },
  { key: 'Parral', value: 'Parral', label: 'Parral' },
  { key: 'Pedro Aguirre Cerda', value: 'Pedro Aguirre Cerda', label: 'Pedro Aguirre Cerda' },
  { key: 'Pelarco', value: 'Pelarco', label: 'Pelarco' },
  { key: 'Pelluhue', value: 'Pelluhue', label: 'Pelluhue' },
  { key: 'Pemuco', value: 'Pemuco', label: 'Pemuco' },
  { key: 'Pencahue', value: 'Pencahue', label: 'Pencahue' },
  { key: 'Penco', value: 'Penco', label: 'Penco' },
  { key: 'Peñaflor', value: 'Peñaflor', label: 'Peñaflor' },
  { key: 'Peñalolén', value: 'Peñalolén', label: 'Peñalolén' },
  { key: 'Peralillo', value: 'Peralillo', label: 'Peralillo' },
  { key: 'Perquenco', value: 'Perquenco', label: 'Perquenco' },
  { key: 'Petorca', value: 'Petorca', label: 'Petorca' },
  { key: 'Peumo', value: 'Peumo', label: 'Peumo' },
  { key: 'Pica', value: 'Pica', label: 'Pica' },
  { key: 'Pichidegua', value: 'Pichidegua', label: 'Pichidegua' },
  { key: 'Pichilemu', value: 'Pichilemu', label: 'Pichilemu' },
  { key: 'Pinto', value: 'Pinto', label: 'Pinto' },
  { key: 'Pirque', value: 'Pirque', label: 'Pirque' },
  { key: 'Pitrufquén', value: 'Pitrufquén', label: 'Pitrufquén' },
  { key: 'Placilla', value: 'Placilla', label: 'Placilla' },
  { key: 'Portezuelo', value: 'Portezuelo', label: 'Portezuelo' },
  { key: 'Porvenir', value: 'Porvenir', label: 'Porvenir' },
  { key: 'Pozo Almonte', value: 'Pozo Almonte', label: 'Pozo Almonte' },
  { key: 'Primavera', value: 'Primavera', label: 'Primavera' },
  { key: 'Providencia', value: 'Providencia', label: 'Providencia' },
  { key: 'Puchuncaví', value: 'Puchuncaví', label: 'Puchuncaví' },
  { key: 'Pucón', value: 'Pucón', label: 'Pucón' },
  { key: 'Pudahuel', value: 'Pudahuel', label: 'Pudahuel' },
  { key: 'Puente Alto', value: 'Puente Alto', label: 'Puente Alto' },
  { key: 'Puerto Montt', value: 'Puerto Montt', label: 'Puerto Montt' },
  { key: 'Puerto Natales', value: 'Puerto Natales', label: 'Puerto Natales' },
  { key: 'Puerto Octay', value: 'Puerto Octay', label: 'Puerto Octay' },
  { key: 'Puerto Varas', value: 'Puerto Varas', label: 'Puerto Varas' },
  { key: 'Pumanque', value: 'Pumanque', label: 'Pumanque' },
  { key: 'Punitaqui', value: 'Punitaqui', label: 'Punitaqui' },
  { key: 'Punta Arenas', value: 'Punta Arenas', label: 'Punta Arenas' },
  { key: 'Puqueldón', value: 'Puqueldón', label: 'Puqueldón' },
  { key: 'Purén', value: 'Purén', label: 'Purén' },
  { key: 'Purranque', value: 'Purranque', label: 'Purranque' },
  { key: 'Putaendo', value: 'Putaendo', label: 'Putaendo' },
  { key: 'Putre', value: 'Putre', label: 'Putre' },
  { key: 'Puyehue', value: 'Puyehue', label: 'Puyehue' },
  { key: 'Queilén', value: 'Queilén', label: 'Queilén' },
  { key: 'Quellón', value: 'Quellón', label: 'Quellón' },
  { key: 'Quemchi', value: 'Quemchi', label: 'Quemchi' },
  { key: 'Quilaco', value: 'Quilaco', label: 'Quilaco' },
  { key: 'Quilicura', value: 'Quilicura', label: 'Quilicura' },
  { key: 'Quilleco', value: 'Quilleco', label: 'Quilleco' },
  { key: 'Quillón', value: 'Quillón', label: 'Quillón' },
  { key: 'Quillota', value: 'Quillota', label: 'Quillota' },
  { key: 'Quilpué', value: 'Quilpué', label: 'Quilpué' },
  { key: 'Quinchao', value: 'Quinchao', label: 'Quinchao' },
  { key: 'Quinta de Tilcoco', value: 'Quinta de Tilcoco', label: 'Quinta de Tilcoco' },
  { key: 'Quinta Normal', value: 'Quinta Normal', label: 'Quinta Normal' },
  { key: 'Quintero', value: 'Quintero', label: 'Quintero' },
  { key: 'Quirihue', value: 'Quirihue', label: 'Quirihue' },
  { key: 'Rancagua', value: 'Rancagua', label: 'Rancagua' },
  { key: 'Ránquil', value: 'Ránquil', label: 'Ránquil' },
  { key: 'Rauco', value: 'Rauco', label: 'Rauco' },
  { key: 'Recoleta', value: 'Recoleta', label: 'Recoleta' },
  { key: 'Renaico', value: 'Renaico', label: 'Renaico' },
  { key: 'Renca', value: 'Renca', label: 'Renca' },
  { key: 'Rengo', value: 'Rengo', label: 'Rengo' },
  { key: 'Requínoa', value: 'Requínoa', label: 'Requínoa' },
  { key: 'Retiro', value: 'Retiro', label: 'Retiro' },
  { key: 'Rinconada', value: 'Rinconada', label: 'Rinconada' },
  { key: 'Río Bueno', value: 'Río Bueno', label: 'Río Bueno' },
  { key: 'Río Claro', value: 'Río Claro', label: 'Río Claro' },
  { key: 'Río Hurtado', value: 'Río Hurtado', label: 'Río Hurtado' },
  { key: 'Río Ibáñez', value: 'Río Ibáñez', label: 'Río Ibáñez' },
  { key: 'Río Negro', value: 'Río Negro', label: 'Río Negro' },
  { key: 'Río Verde', value: 'Río Verde', label: 'Río Verde' },
  { key: 'Romeral', value: 'Romeral', label: 'Romeral' },
  { key: 'Saavedra', value: 'Saavedra', label: 'Saavedra' },
  { key: 'Sagrada Familia', value: 'Sagrada Familia', label: 'Sagrada Familia' },
  { key: 'Salamanca', value: 'Salamanca', label: 'Salamanca' },
  { key: 'San Antonio', value: 'San Antonio', label: 'San Antonio' },
  { key: 'San Bernardo', value: 'San Bernardo', label: 'San Bernardo' },
  { key: 'San Carlos', value: 'San Carlos', label: 'San Carlos' },
  { key: 'San Clemente', value: 'San Clemente', label: 'San Clemente' },
  { key: 'San Esteban', value: 'San Esteban', label: 'San Esteban' },
  { key: 'San Fabián', value: 'San Fabián', label: 'San Fabián' },
  { key: 'San Felipe', value: 'San Felipe', label: 'San Felipe' },
  { key: 'San Fernando', value: 'San Fernando', label: 'San Fernando' },
  { key: 'San Gregorio', value: 'San Gregorio', label: 'San Gregorio' },
  { key: 'San Ignacio', value: 'San Ignacio', label: 'San Ignacio' },
  { key: 'San Javier', value: 'San Javier', label: 'San Javier' },
  { key: 'San Joaquín', value: 'San Joaquín', label: 'San Joaquín' },
  { key: 'San José de Maipo', value: 'San José de Maipo', label: 'San José de Maipo' },
  { key: 'San Juan de la Costa', value: 'San Juan de la Costa', label: 'San Juan de la Costa' },
  { key: 'San Miguel', value: 'San Miguel', label: 'San Miguel' },
  { key: 'San Nicolás', value: 'San Nicolás', label: 'San Nicolás' },
  { key: 'San Pablo', value: 'San Pablo', label: 'San Pablo' },
  { key: 'San Pedro', value: 'San Pedro', label: 'San Pedro' },
  { key: 'San Pedro de Atacama', value: 'San Pedro de Atacama', label: 'San Pedro de Atacama' },
  { key: 'San Pedro de la Paz', value: 'San Pedro de la Paz', label: 'San Pedro de la Paz' },
  { key: 'San Rafael', value: 'San Rafael', label: 'San Rafael' },
  { key: 'San Ramón', value: 'San Ramón', label: 'San Ramón' },
  { key: 'San Rosendo', value: 'San Rosendo', label: 'San Rosendo' },
  { key: 'San Vicente de Tagua Tagua', value: 'San Vicente de Tagua Tagua', label: 'San Vicente de Tagua Tagua' },
  { key: 'Santa Bárbara', value: 'Santa Bárbara', label: 'Santa Bárbara' },
  { key: 'Santa Cruz', value: 'Santa Cruz', label: 'Santa Cruz' },
  { key: 'Santa Juana', value: 'Santa Juana', label: 'Santa Juana' },
  { key: 'Santa María', value: 'Santa María', label: 'Santa María' },
  { key: 'Santiago', value: 'Santiago', label: 'Santiago' },
  { key: 'Santo Domingo', value: 'Santo Domingo', label: 'Santo Domingo' },
  { key: 'Sierra Gorda', value: 'Sierra Gorda', label: 'Sierra Gorda' },
  { key: 'Talagante', value: 'Talagante', label: 'Talagante' },
  { key: 'Talca', value: 'Talca', label: 'Talca' },
  { key: 'Talcahuano', value: 'Talcahuano', label: 'Talcahuano' },
  { key: 'Taltal', value: 'Taltal', label: 'Taltal' },
  { key: 'Temuco', value: 'Temuco', label: 'Temuco' },
  { key: 'Teno', value: 'Teno', label: 'Teno' },
  { key: 'Teodoro Schmidt', value: 'Teodoro Schmidt', label: 'Teodoro Schmidt' },
  { key: 'Tierra Amarilla', value: 'Tierra Amarilla', label: 'Tierra Amarilla' },
  { key: 'Til Til', value: 'Til Til', label: 'Til Til' },
  { key: 'Timaukel', value: 'Timaukel', label: 'Timaukel' },
  { key: 'Tirúa', value: 'Tirúa', label: 'Tirúa' },
  { key: 'Tocopilla', value: 'Tocopilla', label: 'Tocopilla' },
  { key: 'Toltén', value: 'Toltén', label: 'Toltén' },
  { key: 'Tomé', value: 'Tomé', label: 'Tomé' },
  { key: 'Torres del Paine', value: 'Torres del Paine', label: 'Torres del Paine' },
  { key: 'Tortel', value: 'Tortel', label: 'Tortel' },
  { key: 'Traiguén', value: 'Traiguén', label: 'Traiguén' },
  { key: 'Trehuaco', value: 'Trehuaco', label: 'Trehuaco' },
  { key: 'Tucapel', value: 'Tucapel', label: 'Tucapel' },
  { key: 'Valdivia', value: 'Valdivia', label: 'Valdivia' },
  { key: 'Vallenar', value: 'Vallenar', label: 'Vallenar' },
  { key: 'Valparaíso', value: 'Valparaíso', label: 'Valparaíso' },
  { key: 'Vichuquén', value: 'Vichuquén', label: 'Vichuquén' },
  { key: 'Victoria', value: 'Victoria', label: 'Victoria' },
  { key: 'Vicuña', value: 'Vicuña', label: 'Vicuña' },
  { key: 'Vilcún', value: 'Vilcún', label: 'Vilcún' },
  { key: 'Villa Alegre', value: 'Villa Alegre', label: 'Villa Alegre' },
  { key: 'Villa Alemana', value: 'Villa Alemana', label: 'Villa Alemana' },
  { key: 'Villarrica', value: 'Villarrica', label: 'Villarrica' },
  { key: 'Viña del Mar', value: 'Viña del Mar', label: 'Viña del Mar' },
  { key: 'Vitacura', value: 'Vitacura', label: 'Vitacura' },
  { key: 'Yerbas Buenas', value: 'Yerbas Buenas', label: 'Yerbas Buenas' },
  { key: 'Yumbel', value: 'Yumbel', label: 'Yumbel' },
  { key: 'Yungay', value: 'Yungay', label: 'Yungay' },
  { key: 'Zapallar', value: 'Zapallar', label: 'Zapallar' },
]

export const regionOptions = [
  { key: 'Metropolitana de Santiago', value: 'Metropolitana de Santiago', label: 'Metropolitana de Santiago' },
  { key: 'Tarapacá', value: 'Tarapacá', label: 'Tarapacá' },
  { key: 'Antofagasta', value: 'Antofagasta', label: 'Antofagasta' },
  { key: 'Atacama', value: 'Atacama', label: 'Atacama' },
  { key: 'Coquimbo', value: 'Coquimbo', label: 'Coquimbo' },
  { key: 'Valparaíso', value: 'Valparaíso', label: 'Valparaíso' },
  {
    key: 'Libertador General Bernardo O’Higgins',
    value: 'Libertador General Bernardo O’Higgins',
    label: 'Libertador General Bernardo O’Higgins'
  },
  { key: 'Maule', value: 'Maule', label: 'Maule' },
  { key: 'Biobío', value: 'Biobío', label: 'Biobío' },
  { key: 'La Araucanía', value: 'La Araucanía', label: 'La Araucanía' },
  { key: 'Los Lagos', value: 'Los Lagos', label: 'Los Lagos' },
  {
    key: 'Aysén del General Carlos Ibañez del Campo',
    value: 'Aysén del General Carlos Ibañez del Campo',
    label: 'Aysén del General Carlos Ibañez del Campo'
  },
  {
    key: 'Magallanes y de la Antártica Chilena',
    value: 'Magallanes y de la Antártica Chilena',
    label: 'Magallanes y de la Antártica Chilena'
  },
  { key: 'Los Ríos', value: 'Los Ríos', label: 'Los Ríos' },
  { key: 'Arica y Parinacota', value: 'Arica y Parinacota', label: 'Arica y Parinacota' },
  { key: 'Ñuble', value: 'Ñuble', label: 'Ñuble' },
]

export const dayOptions = () => {
  const days: any = []
  for (let i = 1; i < 10; i++) {
    days.push({ key: i.toString() , value: '0' + i, label: '0' + i })
  }
  for (let i = 10; i < 32; i++) {
    days.push({ key: i.toString() , value: i, label: i.toString() })
  }
  return days
}

export const monthOptions = [
    { key: 'Enero', value: '00', label: i18n._('Enero') },
    { key: 'Febrero', value: '01', label: i18n._('Febrero') },
    { key: 'Marzo', value: '02', label: i18n._('Marzo') },
    { key: 'Abril', value: '03', label: i18n._('Abril') },
    { key: 'Mayo', value: '04', label: i18n._('Mayo') },
    { key: 'Junio', value: '05', label: i18n._('Junio') },
    { key: 'Julio', value: '06', label: i18n._('Julio') },
    { key: 'Agosto', value: '07', label: i18n._('Agosto') },
    { key: 'Septiembre', value: '08', label: i18n._('Septiembre') },
    { key: 'Octubre', value: '09', label: i18n._('Octubre') },
    { key: 'Noviembre', value: '10', label: i18n._('Noviembre') },
    { key: 'Diciembre', value: '11', label: i18n._('Diciembre') },
  ]

export const yearOptions = () => {
  const years: any = []
  const currentYear = new Date().getFullYear()

  for (let i = currentYear; i > 1899; i--) {
    years.push({ key: i , value: i.toString(), label: i })
  }
  return years
}
